// src/components/operationCenter/widgets/token/valuation/TwDauDynamicsWidget.tsx
import React from "react";
import type { WidgetProps, TokenWidgetConfig } from "@/types/dashboard";
import { TokenWidgetWrapper } from "../TokenWidgetWrapper";
import { TokenWidgetConfigPanel } from "../TokenWidgetConfig";
import DauDynamicsCard from "@/components/tokenPage/valuation/DauDynamicsCard";

const TwDauDynamicsWidget: React.FC<WidgetProps<TokenWidgetConfig>> = ({
  widget,
  onConfigChange,
}) => {
  const config = widget.config as TokenWidgetConfig;
  return (
    <TokenWidgetConfigPanel config={config} onConfigChange={onConfigChange} widgetType={widget.type}>
      <TokenWidgetWrapper ticker={config.ticker} providers={["fundamentals"]}>
        <DauDynamicsCard />
      </TokenWidgetWrapper>
    </TokenWidgetConfigPanel>
  );
};

export default TwDauDynamicsWidget;
